import React from "react";
import { FormattedNumber } from "react-intl";

class GiftAid extends React.Component {
  render() {
    const { amountWithGiftAid, currencyCode, classColor } = this.props;

    return (
      <div>
        <h3
          className={classColor}
          style={{ visibility: amountWithGiftAid == 0 ? "hidden" : "visible" }}>
          <span className="font-weight-700">Total Gift Aid amount: </span>
          <FormattedNumber
            value={amountWithGiftAid.toFixed(2)}
            style="currency"
            currencyDisplay="symbol"
            currency={currencyCode}
          />
        </h3>
      </div>
    );
  }
}

export default GiftAid;
